import React, { ComponentPropsWithRef } from 'react';
import styled from 'styled-components';

import { Box } from '../Box/Box';
import { LinkButton } from '../Button/Button';
import { GlobalHeader } from '../GlobalHeader/GlobalHeader';
import { DefaultLayout } from '../Layouts/Layouts';
import { Body2 } from '../Typography/Typography';

type LegalPageWrapperProps = {
  children?: React.ReactNode;
};

export const LegalPageWrapper: React.FC<LegalPageWrapperProps> = ({ children }) => {
  return (
    <>
      <GlobalHeader variantOverride="dark" />
      <Box
        display="flex"
        flexGrow={1}
        flexDirection="column"
        alignItems="center"
        height="100%"
        width="100%"
        pt={{ _: 80, md: 56 }}
        px={{ _: 24, md: 240 }}
      >
        <DefaultLayout>
          <Box maxWidth={689} width="100%" pb={36} flexGrow={1} display="flex" flexDirection="column">
            <Box alignSelf="flex-start" my={16} mt={{ md: 80, _: 20 }} color="white">
              {children}
            </Box>
            <StyledLinkButton label="Back to home" to="/" />
          </Box>
        </DefaultLayout>
      </Box>
    </>
  );
};

const StyledLinkButton = styled(LinkButton)`
  margin-top: 2rem;
  align-self: center;
`;

export const LegalH2 = (props: ComponentPropsWithRef<'h2'>) => <StyledH2AsBody2 as="h2" {...props} />;

const StyledH2AsBody2 = styled(Body2)`
  margin: 1rem 0;
  font-weight: 700;
`;

export const LegalBody2 = styled(Body2)`
  margin: 1rem 0;

  a {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const LegalLink = styled.a`
  text-decoration: underline;
  text-underline-offset: 3px;
`;

export const LegalH3 = (props: ComponentPropsWithRef<'h3'>) => <StyledH3AsBody2 as="h3" {...props} />;

const StyledH3AsBody2 = styled(Body2)`
  margin: 1.5rem 0 0.5rem;
  font-weight: 700;
`;

export const LegalUl = styled.ul`
  padding-top: 8px;
  padding-left: 1.5rem;
  margin: 0.5rem 0 1rem;
  list-style-type: disc;
  font-family: ${(props) => (props as any).theme?.fonts?.body};
  font-size: 1.25rem;
  font-size: clamp(1rem, calc(1rem + ((1vw - 0.2rem) * 0.25)), 1.25rem);
  font-weight: 400;
  line-height: 1.5;

  li {
    margin-bottom: 0.5rem;

    a {
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }
`;
